import type {Lock} from 'services/locks/types';
import type {UserDto} from 'services/users/types';

export const isLockedByOtherUser = (
  lock: Lock | undefined,
  user: Pick<UserDto, 'id'> | undefined | null,
) => {
  return !!lock && !!user && lock.lockedBy !== user.id;
};
